<template>
  <div class="week-calendar">
    <div class="week-calendar-header">
      <!-- Display the dates of the week -->
      <div v-for="day in weekDates" :key="day" class="day-header">
        {{ day }}
      </div>
    </div>
    <div class="week-calendar-time-slots">
      <!-- Display time slots -->
      <div class="time-slot" v-for="timeSlot in timeSlots" :key="timeSlot">
        {{ timeSlot }}
      </div>
    </div>
    <div class="week-calendar-events">
      <!-- Display events for each day -->
      <div v-for="day in weekDates" :key="day" class="day-events">
        <h3>{{ day }}</h3>
        <div v-for="timeSlot in timeSlots" :key="timeSlot" class="event">
          {{ getEventForDayAndTime(day, timeSlot).title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    eventsData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      timeSlots: [
        "8:00 AM",
        "9:00 AM",
        "10:00 AM",
        "11:00 AM",
        "12:00 PM",
        "1:00 PM",
        "2:00 PM",
        "3:00 PM",
        "4:00 PM",
        "5:00 PM",
      ],
    };
  },
  computed: {
    // Calculate the dates for the week (7 days)
    weekDates() {
      const startDate = new Date();
      const dates = [];
      for (let i = 0; i < 7; i++) {
        const date = new Date(startDate);
        date.setDate(startDate.getDate() + i);
        dates.push(date.toLocaleDateString("en-US"));
      }
      return dates;
    },
  },
  methods: {
    // Get event for a specific day and time slot
    getEventForDayAndTime(day, timeSlot) {
      return this.eventsData.find((event) => {
        const eventDate = new Date(event.date);
        const eventTime = eventDate.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return (
          eventDate.toLocaleDateString("en-US") === day && eventTime === timeSlot
        );
      });
    },
  },
};
</script>

<style scoped>
.week-calendar {
  /* Add your styles for the week calendar container */
}

.week-calendar-header {
  /* Add styles for the header section */
  display: flex;
  justify-content: space-between;
}

.day-header {
  /* Add styles for each day header */
  flex: 1;
  text-align: center;
  border: 1px solid #ccc;
  padding: 10px;
}

.week-calendar-time-slots {
  /* Add styles for the time slots section */
  width: 100px; /* Adjust width as needed */
}

.time-slot {
  /* Add styles for each time slot */
  border: 1px solid #ccc;
  padding: 10px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #f0f0f0;
}

.week-calendar-events {
  /* Add styles for the events section */
  display: flex;
  justify-content: space-between;
}

.day-events {
  /* Add styles for each day's events */
  flex: 1;
  border: 1px solid #ccc;
  padding: 10px;
  margin: 0 5px;
}

.event {
  /* Add styles for each event */
  margin-bottom: 5px;
}
</style>
